import React, { FormEvent, useState } from "react";
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import { Link } from "react-router-dom";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import baconLogo from "../../assets/images/baconappen.png";
import { apiFetch } from "../../helpers/api";

const ForgetPasswordPage = () => {
  const [correo, setCorreo] = useState("");
  const [mensajeExito, setMensajeExito] = useState("");
  const [mensajeError, setMensajeError] = useState("");
  const [cargando, setCargando] = useState(false);

  const manejarEnvio = async (evento: FormEvent<HTMLFormElement>) => {
    evento.preventDefault();
    setMensajeExito("");
    setMensajeError("");

    const correoLimpio = correo.trim().toLowerCase();
    if (!correoLimpio) {
      setMensajeError("Ingresa tu correo corporativo para continuar.");
      return;
    }

    setCargando(true);
    try {
      const respuesta = await apiFetch("/api/auth/recuperacion", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ identificador: correoLimpio }),
      });

      if (!respuesta.ok) {
        throw new Error("No se pudo iniciar el proceso de recuperación.");
      }

      setMensajeExito(
        "Si el correo está registrado, enviaremos las instrucciones para restablecer tu contraseña."
      );
      setCorreo("");
    } catch (error) {
      console.error(error);
      setMensajeError("No se pudo solicitar la recuperación. Inténtalo más tarde.");
    } finally {
      setCargando(false);
    }
  };

  return (
    <ParticlesAuth>
      <div className="auth-page-content mt-lg-5">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="auth-login-brand text-center mt-sm-5 mb-4 text-white-50">
                <div>
                  <Link to="/" className="d-inline-block auth-logo">
                    <img src={baconLogo} alt="BaconApp logo" className="logo-white-filter" height="32" />
                  </Link>
                </div>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={6} lg={5} xl={4}>
              <Card className="mt-4 auth-login-card">
                <CardBody className="px-5 py-5">
                  <CardTitle tag="h5" className="text-center mb-3">
                    Recuperar contraseña
                  </CardTitle>
                  <p className="text-muted text-center">
                    Ingresa tu correo corporativo y te enviaremos un enlace seguro para restablecer tu contraseña.
                  </p>

                  {mensajeExito && (
                    <Alert color="success" toggle={() => setMensajeExito("")}>
                      {mensajeExito}
                    </Alert>
                  )}
                  {mensajeError && (
                    <Alert color="danger" toggle={() => setMensajeError("")}>
                      {mensajeError}
                    </Alert>
                  )}

                  <Form className="mt-4" onSubmit={manejarEnvio}>
                    <FormGroup className="mb-3">
                      <Label htmlFor="recuperar-email">Correo corporativo</Label>
                      <Input
                        id="recuperar-email"
                        type="email"
                        placeholder="tucorreo@baconburgers.com.py"
                        value={correo}
                        onChange={(e) => setCorreo(e.target.value)}
                        disabled={cargando}
                      />
                    </FormGroup>
                    <Button color="success" type="submit" className="w-100" disabled={cargando}>
                      {cargando ? (
                        <>
                          <Spinner size="sm" className="me-2" /> Enviando...
                        </>
                      ) : (
                        "Enviar instrucciones"
                      )}
                    </Button>
                  </Form>

                  <p className="text-center text-muted mt-4">
                    ¿Volver al inicio de sesión?{" "}
                    <Link to="/login" className="fw-semibold text-primary text-decoration-underline">
                      Ir al login
                    </Link>
                  </p>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </ParticlesAuth>
  );
};

export default ForgetPasswordPage;
